<template>
	<div class="sk-h-100">
		<section class="sk-comform-white-box">
			<div class="mobjd-jobdetails skillback-trans">
				<section class="skform-text-right">
					<div id="hideinmobile" class="candash-modal-label d-flex">
						Added Technical Skills
					</div>
					<div id="hideinlaptop">Your Technical Skills</div>
					<!-- <div class="upCandDoc-unselected-box-head-3 mb-1">
						(Min 3 required for graphical resume)
					</div> -->
					<div class="candash-modal-overflow-3" v-if="techShimmer">
						<div class="d-flex flex-wrap gap-2">
							<b-skeleton
								v-for="i in 4"
								:key="i"
								type="input"
								class="skill-pill-shimmer"
							></b-skeleton>
						</div>
					</div>
					<main v-else-if="techSkills.length" class="candash-modal-overflow-3">
						<div class="d-flex flex-wrap gap-2">
							<div
								v-for="(skill, index) in techSkills"
								:key="index + 'tech'"
								class="px-2 py-1"
								:class="
									selectedTechSkill.priorityID === skill.priorityID
										? 'skill-pill-sel'
										: 'skill-pill pointer'
								"
								@click="editTechSkill(skill)"
							>
								{{ skill.skillName }}
								<img
									v-if="selectedTechSkill.priorityID === skill.priorityID"
									class="ml-1"
									src="@/assets/newdesign/dashboard/whiteTick.svg"
									alt=""
								/>
								<img
									@click="removeTechSkill(index)"
									@click.stop
									v-else
									class="ml-1 pointer"
									src="@/assets/newdesign/dashboard/roundBlueCross.svg"
									alt=""
								/>
							</div>
						</div>
					</main>
					<template v-if="parserTechSkills.length > 0">
						<div class="job-description-subfont-2 mb-1 mt-3">
							Skills from your resume (Technical Skills)
						</div>
						<main
							v-if="parserTechSkills.length"
							class="candash-modal-overflow-3"
						>
							<div class="d-flex flex-wrap gap-2">
								<div
									v-for="(skill, index) in parserTechSkills"
									:key="index + 'tech'"
									class="px-2 py-1"
									:class="
										skill.parser && selectedTechSkill.id == skill.id
											? 'candash-brownTag-selected'
											: skill.parser
											? 'candash-brownTag pointer'
											: ''
									"
									@click="editTechSkill(skill)"
								>
									{{ skill.skillName }}
									<img
										v-if="selectedTechSkill.id === skill.id"
										class="ml-1"
										src="@/assets/newdesign/dashboard/parsertick.svg"
										alt=""
									/>
									<img
										v-else
										@click.stop="removeParserTechSkill(index)"
										class="ml-1 pointer"
										src="@/assets/newdesign/dashboard/roundBlueCross.svg"
										alt=""
									/>
								</div>
							</div>
						</main>
					</template>
				</section>

				<section class="skform-text-left">
					<div id="hideinmobile" class="job-description-font">
						Technical Skills
					</div>
					<div
						id="hideinlaptop"
						class="skform-grey-txt mt-2"
						v-if="techSkills.length > 0"
					>
						Add another technical skill
					</div>
					<b-row v-if="techSkillLoader">
						<b-col cols="12" class="d-flex mt-3">
							<label id="hideinmobile" class="teams-label-font w-40"
								>Skill</label
							>
							<b-skeleton type="input" class="w-90"></b-skeleton>
						</b-col>
						<b-col class="mt-3 d-flex" cols="12">
							<label id="hideinmobile" class="teams-label-font w-40"
								>Expertise Level</label
							>
							<b-skeleton type="input" class="w-90"></b-skeleton>
						</b-col>
					</b-row>
					<b-row v-else>
						<b-col
							v-for="(field, index) in techSkillsFields"
							:key="index"
							:cols="getColumn(field.controlType)"
							class="relativeclass"
							:class="
								field.controlType == 'boolean'
									? 'd-flex align-items-center'
									: ''
							"
							v-show="!field.hide"
						>
							<div v-if="field.key == 'skillName'" class="topDiv mt-3">
								<Selectwithsearch
									:id="field.key"
									:label="field.label"
									:type="field.controlType"
									:mandatory="field.mandatory"
									:placeholder="field.placeholder"
									:showError="getTechError(field)"
									:vmodel="getTechVmodel(field)"
									@select-value="onTechSkillSelectValue(field, $event)"
									:hideSuggestList="hideSuggestList"
									@reset-suggestList-cond="resetCloseCondition"
								/>
							</div>

							<div v-if="field.key == 'expertiseLevel'" class="mt-3">
								<ExpertiseLevel
									:id="field.key"
									:label="field.label"
									:type="field.controlType"
									:mandatory="field.mandatory"
									:placeholder="field.placeholder"
									:options="field.values"
									:showError="getTechError(field)"
									:vmodel="getTechVmodel(field)"
									@select-value="updateTechFieldValue(field, $event)"
								/>
							</div>
							<template v-if="techtouchedFields[field.key]">
								<div
									class="newInt-required-validation-font mt-1 sk-error-txt"
									v-if="field.mandatory && !validateTechField(field)"
								>
									{{ techValText[field.key] }}
								</div>
								<div
									class="newInt-required-validation-font mt-1 sk-error-txt"
									v-else-if="field.limit > 0 && !validateTechField(field)"
								>
									{{ techValText[field.key] }}
								</div>
							</template>
						</b-col>
					</b-row>
					<div class="skill-modal-flex gap-10 mt-3">
						<template v-if="techSkillEdit">
							<div
								class="bold-bluetxt"
								:class="
									deepEqual(selectedTechSkill, techSkillObject)
										? 'opac-5 defaultCursor'
										: 'pointer'
								"
								@click="
									deepEqual(selectedTechSkill, techSkillObject)
										? ''
										: discardTechSkill()
								"
							>
								Discard
							</div>
							<div class="blueline"></div>
							<div
								@click.stop="validateTechForm()"
								class="bold-bluetxt pointer"
							>
								Update
							</div>
						</template>
						<div
							@click.stop="validateTechForm()"
							v-else
							class="bold-bluetxt pointer d-flex align-items-center gap-1"
						>
							<img
								src="../../assets/newdesign/dashboard/blueRoundAdd.svg"
								alt=""
							/>
							Add
						</div>
					</div>
				</section>
			</div>
			<hr id="hideinmobile" class="hr-back my-0" />
			<div class="mobjd-jobdetails skillback-trans">
				<section class="skform-text-right">
					<div id="hideinmobile" class="candash-modal-label d-flex">
						Added Interpersonal Skills
					</div>
					<div id="hideinlaptop">Your Interpersonal Skills</div>
					<!-- <div class="upCandDoc-unselected-box-head-3 mb-1">
						(Min 3 required for graphical resume)
					</div> -->
					<div class="candash-modal-overflow-3" v-if="interShimmer">
						<div class="d-flex flex-wrap gap-2">
							<b-skeleton
								v-for="i in 4"
								:key="i"
								type="input"
								class="skill-pill-shimmer"
							></b-skeleton>
						</div>
					</div>
					<main v-else-if="interSkills.length" class="candash-modal-overflow-3">
						<div class="d-flex flex-wrap gap-2">
							<div
								v-for="(skill, index) in interSkills"
								:key="index + 'inter'"
								class="px-2 py-1"
								:class="
									selectedInterSkill.priorityID === skill.priorityID
										? 'skill-pill-sel'
										: 'skill-pill pointer'
								"
								@click="editInterSkill(skill)"
							>
								{{ skill.skillName }}
								<img
									v-if="selectedInterSkill.priorityID === skill.priorityID"
									class="ml-1"
									src="@/assets/newdesign/dashboard/whiteTick.svg"
									alt=""
								/>
								<img
									@click="removeInterSkill(index)"
									@click.stop
									v-else
									class="ml-1 pointer"
									src="@/assets/newdesign/dashboard/roundBlueCross.svg"
									alt=""
								/>
							</div>
						</div>
					</main>
					<template v-if="parserInterSkills.length > 0">
						<div class="job-description-subfont-2 mb-1 mt-3">
							Skills from your resume (Interpersonal Skills)
						</div>
						<main class="candash-modal-overflow-3">
							<div class="d-flex flex-wrap gap-2">
								<div
									v-for="(skill, index) in parserInterSkills"
									:key="index + 'inter'"
									class="px-2 py-1"
									:class="
										skill.parser && selectedInterSkill.id == skill.id
											? 'candash-brownTag-selected'
											: skill.parser
											? 'candash-brownTag pointer'
											: ''
									"
									@click="editInterSkill(skill)"
								>
									{{ skill.skillName }}
									<img
										v-if="selectedInterSkill.id === skill.id"
										class="ml-1"
										src="@/assets/newdesign/dashboard/parsertick.svg"
										alt=""
									/>
									<img
										@click="removeParserInterSkill(index)"
										@click.stop
										v-else
										class="ml-1 pointer"
										src="@/assets/newdesign/dashboard/roundBlueCross.svg"
										alt=""
									/>
								</div>
							</div>
						</main>
					</template>
				</section>

				<section class="skform-text-left">
					<div id="hideinmobile" class="job-description-font">
						Interpersonal Skills
					</div>
					<div
						id="hideinlaptop"
						class="skform-grey-txt mt-2"
						v-if="interSkills.length > 0"
					>
						Add another skill
					</div>
					<b-row v-if="interSkillLoader">
						<b-col cols="12" class="d-flex mt-3">
							<label id="hideinmobile" class="teams-label-font w-40"
								>Skill</label
							>
							<b-skeleton type="input" class="w-90"></b-skeleton>
						</b-col>
						<b-col class="mt-3 d-flex" cols="12">
							<label id="hideinmobile" class="teams-label-font w-40"
								>Expertise Level</label
							>
							<b-skeleton type="input" class="w-90"></b-skeleton>
						</b-col>
					</b-row>
					<b-row v-else>
						<b-col
							v-for="(field, index) in interSkillsFields"
							:key="index"
							:cols="getColumn(field.controlType)"
							class="relativeclass"
							:class="
								field.controlType == 'boolean'
									? 'd-flex align-items-center'
									: ''
							"
							v-show="!field.hide"
						>
							<div v-if="field.key == 'skillName'" class="topDiv mt-3">
								<InputField
									:id="field.key"
									:label="field.label"
									:type="field.controlType"
									:mandatory="field.mandatory"
									:placeholder="field.placeholder"
									:showError="getInterError(field)"
									:vmodel="getInterVmodel(field)"
									@select-value="updateInterFieldValue(field, $event)"
								/>
							</div>

							<div v-if="field.key == 'expertiseLevel'" class="mt-3">
								<ExpertiseLevel
									:id="field.key"
									:label="field.label"
									:type="field.controlType"
									:mandatory="field.mandatory"
									:placeholder="field.placeholder"
									:options="field.values"
									:showError="getInterError(field)"
									:vmodel="getInterVmodel(field)"
									nolabel
									@select-value="updateInterFieldValue(field, $event)"
								/>
							</div>

							<template v-if="intertouchedFields[field.key]">
								<div
									class="newInt-required-validation-font mt-1 sk-error-txt"
									v-if="field.mandatory && !validateInterField(field)"
								>
									{{ interValText[field.key] }}
								</div>
								<div
									class="newInt-required-validation-font mt-1 sk-error-txt"
									v-else-if="field.limit > 0 && !validateInterField(field)"
								>
									{{ interValText[field.key] }}
								</div>
							</template>
						</b-col>
					</b-row>
					<div class="skill-modal-flex gap-10 mt-3">
						<template v-if="interSkillEdit">
							<div
								class="bold-bluetxt"
								:class="
									deepEqual(selectedInterSkill, interSkillObject)
										? 'opac-5 defaultCursor'
										: 'pointer'
								"
								@click="
									deepEqual(selectedInterSkill, interSkillObject)
										? ''
										: discardInterSkill()
								"
							>
								Discard
							</div>
							<div class="blueline"></div>
							<div
								@click.stop="validateInterForm()"
								class="bold-bluetxt pointer"
							>
								Update
							</div>
						</template>
						<div
							@click.stop="validateInterForm()"
							v-else
							class="bold-bluetxt pointer d-flex align-items-center gap-1"
						>
							<img
								src="../../assets/newdesign/dashboard/blueRoundAdd.svg"
								alt=""
							/>
							Add
						</div>
					</div>
				</section>
			</div>
			<hr id="hideinmobile" class="hr-back my-0" />
			<div class="mobjd-jobdetails skillback-trans">
				<section class="skform-text-right">
					<div id="hideinmobile" class="candash-modal-label d-flex">
						Added Interests / Hobbies
					</div>
					<div id="hideinlaptop">Your Interest / Hobbies</div>
					<!-- <div
						v-if="
							checkDynamic &&
							checkDynamic.hobbies &&
							checkDynamic.hobbies.isMandatory
						"
						class="upCandDoc-unselected-box-head-3 mb-1"
					>
						(Min 3 required for graphical resume)
					</div> -->
					<div class="candash-modal-overflow-3" v-if="hobbyShimmer">
						<div class="d-flex flex-wrap gap-2">
							<b-skeleton
								v-for="i in 4"
								:key="i"
								type="input"
								class="skill-pill-shimmer"
							></b-skeleton>
						</div>
					</div>
					<main v-else-if="hobbies.length" class="candash-modal-overflow-3">
						<div class="d-flex flex-wrap gap-2">
							<div
								v-for="(hobby, index) in hobbies"
								:key="index + 'tech'"
								class="px-2 py-1"
								:class="
									selectedHobby === hobby
										? 'skill-pill-sel'
										: 'skill-pill pointer'
								"
								@click="editHobby(hobby, index)"
							>
								{{ hobby }}
								<img
									v-if="selectedHobby === hobby"
									class="ml-1"
									src="@/assets/newdesign/dashboard/whiteTick.svg"
									alt=""
								/>
								<img
									@click="removeHobby(index)"
									@click.stop
									v-else
									class="ml-1 pointer"
									src="@/assets/newdesign/dashboard/roundBlueCross.svg"
									alt=""
								/>
							</div>
						</div>
					</main>
					<template v-if="parserHobbies.length > 0">
						<div class="job-description-subfont-2 mb-1 mt-3">
							Skills from your resume (Interpersonal Skills)
						</div>
						<div class="d-flex flex-wrap gap-2">
							<div
								v-for="(hobby, index) in parserHobbies"
								:key="index + 'tech'"
								class="px-2 py-1"
								:class="
									selectedHobby === hobby
										? 'candash-brownTag-selected'
										: 'candash-brownTag pointer'
								"
								@click="editHobby(hobby, index, true)"
							>
								{{ hobby }}
								<img
									v-if="selectedHobby === hobby"
									class="ml-1"
									src="@/assets/newdesign/dashboard/parsertick.svg"
									alt=""
								/>
								<img
									@click="removeParserHobby(index)"
									@click.stop
									v-else
									class="ml-1 pointer"
									src="@/assets/newdesign/dashboard/roundBlueCross.svg"
									alt=""
								/>
							</div>
						</div>
					</template>
				</section>

				<section class="skform-text-left">
					<div id="hideinmobile" class="job-description-font">
						Interests / Hobbies<span class="asterik" v-if="hobbiesMandatory"
							>*</span
						>
					</div>
					<div
						id="hideinlaptop"
						class="skform-grey-txt mt-2"
						v-if="hobbies.length > 0"
					>
						Add another hobby
					</div>
					<b-row v-if="hobbyLoader">
						<b-col cols="12" class="mt-3">
							<b-skeleton type="input"></b-skeleton>
						</b-col>
					</b-row>
					<b-row v-else>
						<b-col
							v-for="(field, index) in hobbyFields"
							:key="index"
							:cols="getColumn(field.controlType)"
							class="relativeclass"
							:class="
								field.controlType == 'boolean'
									? 'd-flex align-items-center'
									: ''
							"
							v-show="!field.hide"
						>
							<div v-if="field.key == 'hobbies'" class="topDiv mt-3">
								<Selectwithsearch
									:id="field.key"
									:label="field.label"
									:type="field.controlType"
									:mandatory="field.mandatory"
									:placeholder="field.placeholder"
									:options="filteredHobbyOptions(field.values, hobbies)"
									:isAdd="true"
									:showError="getHobbyError(field)"
									:vmodel="getHobbyVmodel(field)"
									@select-value="updateHobbyFieldValue(field, $event)"
									@add-value="validateHobbyForm()"
									:hideSuggestList="hideSuggestList"
									@reset-suggestList-cond="resetCloseCondition"
								/>
							</div>

							<template v-if="hobbytouchedFields[field.key]">
								<div
									class="newInt-required-validation-font mt-1"
									v-if="field.mandatory && !validateHobbyField(field)"
								>
									{{ hobbyValText[field.key] }}
								</div>
								<div
									class="newInt-required-validation-font mt-1"
									v-else-if="field.limit > 0 && !validateHobbyField(field)"
								>
									{{ hobbyValText[field.key] }}
								</div>
							</template>
						</b-col>
					</b-row>
					<div class="skill-modal-flex gap-10 mt-3">
						<template v-if="hobbyEdit">
							<div
								class="bold-bluetxt"
								:class="
									selectedHobby == hobbyObject.hobbies
										? 'opac-5 defaultCursor'
										: 'pointer'
								"
								@click="
									selectedHobby == hobbyObject.hobbies ? '' : discardHobby()
								"
							>
								Discard
							</div>
							<div class="blueline"></div>
							<div
								@click.stop="validateHobbyForm()"
								class="bold-bluetxt pointer"
							>
								Update
							</div>
						</template>
						<div
							@click.stop="validateHobbyForm()"
							v-else
							class="bold-bluetxt pointer d-flex align-items-center gap-1"
						>
							<img
								src="../../assets/newdesign/dashboard/blueRoundAdd.svg"
								alt=""
							/>
							Add
						</div>
					</div>
				</section>
			</div>
		</section>
		<footer class="sk-footer px-3">
			<div class="mob-cancelBtn sk-w-50">
				<b-button class="w-100" @click="$emit('cancel')">Cancel</b-button>
			</div>
			<div class="mob-addBtn position-relative sk-w-50">
				<b-button
					class="w-100"
					@click="saveSkillsAndHobbies()"
					:class="
						loader ? 'loader-class-mobapply-save defaultCursor' : 'pointer'
					"
					:disabled="loader"
					>{{ loader ? "" : "Save" }}</b-button
				>
				<div v-if="loader" class="loader-pos-new">
					<Loader />
				</div>
			</div>
		</footer>
	</div>
</template>

<script>
import skillForm from "@/controllers/dashboard/mixin/skillForm";
export default {
	data() {
		return {};
	},
	mixins: [skillForm],
};
</script>
<style>
.skill-pill-shimmer {
	height: 25px;
	width: 120px;
	border-radius: 1.5rem;
}
.skill-pill {
	font-size: 12px;
	font-weight: 500;
	font-family: "montserrat", sans-serif;
	color: #20639b;
	border-radius: 20px;
	display: flex;
	align-items: center;
	background: #f1f7ff;
	height: fit-content;
}
.skill-pill-sel {
	font-size: 12px;
	font-weight: 500;
	font-family: "montserrat", sans-serif;
	color: #ffffff;
	border-radius: 20px;
	display: flex;
	align-items: center;
	background: #5688b3;
	height: fit-content;
}
.gap-10 {
	gap: 10px;
}

.skillback-trans {
	display: flex;
	flex-direction: row-reverse;
	gap: 20px;
	background-color: #fff;
	padding: 12px 0px 15px 0px;
}

.skform-grey-txt {
	font-family: "Inter", sans-serif;
	font-size: 13px;
	font-weight: 400;
	color: #667085;
}

.skform-text-left {
	width: 50%;
}

.skform-text-right {
	width: 50%;
	padding-left: 40px;
}

.sk-comform-white-box {
	background-color: #ffffff;
	border-radius: 4px;
	display: flex;
	flex-direction: column;
	gap: 0px;
	/* min-height: auto;
	max-height: calc(100vh - 240px); */
	height: calc(100vh - 265px);
	max-height: 575px;
	padding: 15px 40px 15px 15px;
	overflow: auto;
}
.skill-modal-flex {
	display: flex;
	align-items: center;
	justify-content: flex-end;
}

.sk-footer {
	background-color: #ffffff;
	border-top: 1px solid #e2e2e2;
	padding-block: 15px;
	display: flex;
	align-items: center;
	justify-content: flex-end;
	height: unset;
	border-bottom-right-radius: 15px;
	gap: 20px;
}
.sk-w-50 {
	width: 10%;
}

.sk-error-txt {
	position: absolute;
	left: 31%;
}
@media (max-width: 1028px) {
	.skill-pill,
	.skill-pill-sel {
		border: 1px solid #d0d5dd;
	}
	.skillback-trans {
		display: flex;
		flex-direction: column;
		gap: 5px;
		background-color: #f7f9fb;
		border-bottom: none;
		padding: 10px;
	}
	.skill-modal-flex {
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.skform-text-left {
		width: unset;
	}
	.skform-text-right {
		width: unset;
		padding-left: unset;
	}
	.sk-comform-white-box {
		background-color: #ffffff;
		border-radius: 4px;
		display: flex;
		flex-direction: column;
		gap: 20px;
		min-height: unset;
		max-height: unset;
		height: 92%;
		padding: 15px;
		overflow: auto;
	}
	.sk-footer {
		background-color: #ffffff;
		border-top: 1px solid #e2e2e2;
		padding: 5px;
		display: flex;
		align-items: center;
		height: 8%;
		justify-content: unset;
		border-bottom-right-radius: 0px;
	}
	.sk-w-50 {
		width: 50%;
	}
	.sk-h-100 {
		height: 100%;
		width: 100%;
	}
	.candash-modal-overflow-3 {
		min-height: unset;
		max-height: unset;
		overflow: unset;
	}
	.sk-error-txt {
		position: absolute;
		left: 5%;
	}
}
</style>
